module.exports = __webpack_public_path__ + "videos/about-1025.e4e19a4.mp4";